/* POP3 reaction lander v2: carousel arrows + progress track. Swipe works without this file.
   Loaded by several sections; the guards keep it to one set of listeners per carousel. */
(function () {
  if (window.npPop3Car) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(car) {
    if (car.hasAttribute('data-car-ready')) return;
    var track = car.querySelector('.car-track');
    var ctl = car.querySelector('.car-ctl');
    if (!track || !ctl || !track.firstElementChild) return;
    car.setAttribute('data-car-ready', '');
    var prev = ctl.querySelector('.car-prev');
    var next = ctl.querySelector('.car-next');
    var thumb = ctl.querySelector('.car-thumb');
    var cur = 0, settle;

    function maxX() { return track.scrollWidth - track.clientWidth; }
    function lefts() {
      var f = track.firstElementChild, out = [];
      for (var k = 0; k < track.children.length; k++) out.push(track.children[k].offsetLeft - f.offsetLeft);
      return out;
    }
    function lastReach(L, max) {
      for (var k = 0; k < L.length; k++) if (L[k] >= max - 2) return k;
      return L.length - 1;
    }
    function nearest() {
      var L = lefts(), max = maxX(), x = track.scrollLeft, best = 0, d = Infinity;
      if (x >= max - 2) return lastReach(L, max);
      for (var k = 0; k < L.length; k++) { var dd = Math.abs(L[k] - x); if (dd < d) { d = dd; best = k; } }
      return best;
    }
    function update() {
      var max = maxX();
      var on = max > 4;
      ctl.hidden = !on;
      if (on) {
        track.setAttribute('tabindex', '0');
        var x = Math.min(Math.max(track.scrollLeft, 0), max);
        var vis = track.clientWidth / track.scrollWidth;
        prev.disabled = x <= 2;
        next.disabled = x >= max - 2;
        thumb.style.width = (vis * 100) + '%';
        thumb.style.left = ((x / max) * (1 - vis) * 100) + '%';
      } else {
        track.removeAttribute('tabindex');
      }
    }
    function go(dir) {
      var L = lefts(), max = maxX();
      cur = Math.max(0, Math.min(lastReach(L, max), cur + dir));
      track.scrollTo({ left: Math.min(L[cur], max), behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    track.addEventListener('scroll', function () {
      update();
      clearTimeout(settle);
      settle = setTimeout(function () { cur = nearest(); }, 160);
    }, { passive: true });
    window.addEventListener('resize', function () { update(); cur = nearest(); });
    window.addEventListener('load', update);
    update();
  }

  function init(root) {
    var cars = (root || document).querySelectorAll('.np-pop3 [data-car]');
    for (var i = 0; i < cars.length; i++) setup(cars[i]);
  }

  window.npPop3Car = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
